// pages/[slug] renders the landing page for every unmatched top-level path,
// so browsers and scanners asking for root files (/favicon.ico,
// /apple-touch-icon.png, /xmlrpc.php, /.env.backup) land there too. These are
// file requests, not landing pages. Match on known file extensions rather than
// any dot, so a landing page given a dotted slug in Contentful still renders.
const FILE_EXTENSIONS = new Set([
  'png',
  'jpg',
  'jpeg',
  'gif',
  'svg',
  'webp',
  'ico',
  'txt',
  'xml',
  'json',
  'js',
  'css',
  'map',
  'html',
  'htm',
  'php',
  'asp',
  'aspx',
  'jsp',
  'cgi',
  'env',
  'bak',
  'backup',
  'old',
  'sql',
  'zip',
  'gz',
  'tar',
  'rar',
  'yml',
  'yaml',
  'ini',
  'log',
  'conf',
  'cfg',
])

export const isFileRequestSlug = (slug: string) => {
  if (slug.startsWith('.')) return true
  const dot = slug.lastIndexOf('.')
  return dot > 0 && FILE_EXTENSIONS.has(slug.slice(dot + 1).toLowerCase())
}

// The unknown slug, for the server log, when it is shaped like a landing-page
// slug. Anything else (an email address, free text) is not logged.
export const loggableSlug = (slug: string) =>
  /^[A-Za-z0-9_-]{1,64}$/.test(slug) ? slug : '[not slug-shaped]'
